// extracted by mini-css-extract-plugin
export default {"content":"content__OAysFB0","bottomnav":"bottomnav__-d8H+Tu","main":"main__-m-4qWT"};